import React from 'react';
import Header from '../../Header';

import './tarifs.css'

import toptarif from '../../../assets/images/toptarif.png';


const Tarifs = ({ openBurger, isOpen }) => {
    return (
        <div className="tarifs">
            <Header openBurger={openBurger} isOpen={isOpen} title="Tarifs" />
            <div className="tarif-main">
                <img className="top-tarif" src={toptarif} alt="" />
                <div className="tarif">
                    <h2 className="tarif-title">TARIFS</h2>
                    <ul className="lists">
                        <h4>MIGNARDISES:</h4>
                        <li>Magnum 1,50€</li>
                        <li>Pop cake 1€</li>
                        <li>Cupcake grand 1€</li>
                        <li>Cupcake mini 0,60€</li>
                        <li>Sucette meringue 0,70€</li>
                        <li>Tiramisu 1€</li>
                        <li>Citron merringue 1€</li>
                        <li>Mousse chocolat blanc 1€</li>
                        <p className="info-tarif">Minimum 10 pièces par couleur et par gouts.</p>
                    </ul>

                    <ul className="lists">
                        <h4>NUMBER CAKE:</h4>
                        <li>Format a4 6/8parts 30€ à partir de 2 chiffres 25€</li>
                        <li>Format a3 10/12parts 40€ à partir de 2 chiffres 35€</li>
                        <p className="info-tarif">Un accompte non remboursable de 50% est obligatoire pour valider la commande</p>
                    </ul>

                    <p className="info-tarif">Pour le reste, devis sur demande</p>

                </div>
            </div>
        </div>
    );
};

export default Tarifs;